import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell, Receipt, UploadSimple } from "@phosphor-icons/react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

export default function AdminNotifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const loadCount = useCallback(() => {
    api.get("/admin/notifications/unread-count").then((r) => setUnread(r.data.count)).catch(() => {});
  }, []);

  useEffect(() => {
    loadCount();
    const t = setInterval(loadCount, 30000);
    return () => clearInterval(t);
  }, [loadCount]);

  const openMenu = async (open) => {
    if (!open) return;
    try {
      const r = await api.get("/admin/notifications");
      setItems(r.data);
      if (r.data.some((n) => !n.is_read)) {
        await api.post("/admin/notifications/read-all");
        setUnread(0);
      }
    } catch {}
  };

  return (
    <DropdownMenu onOpenChange={openMenu}>
      <DropdownMenuTrigger data-testid="admin-bell" className="relative text-white hover:text-[#E8662B] transition-colors focus:outline-none">
        <Bell weight="bold" size={23} />
        {unread > 0 && (
          <span data-testid="admin-bell-count" className="absolute -top-1.5 -right-1.5 bg-[#E8662B] text-white text-[10px] font-bold min-w-[18px] h-[18px] rounded-full flex items-center justify-center px-1">{unread > 99 ? "99+" : unread}</span>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-96 overflow-y-auto">
        <DropdownMenuLabel className="flex items-center justify-between">Notificaciones <span className="text-xs text-muted-foreground font-normal">Ventas y pedidos</span></DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.length === 0 ? (
          <p className="px-3 py-6 text-center text-sm text-muted-foreground">Sin notificaciones</p>
        ) : (
          items.map((n) => (
            <button key={n.id} data-testid={`notif-${n.id}`}
                    onClick={() => { if (n.order_id) navigate("/admin"); }}
                    className={`w-full text-left px-3 py-2.5 hover:bg-secondary/60 flex gap-2 border-b border-black/5 last:border-0 ${!n.is_read ? "bg-primary/5" : ""}`}>
              <span className="mt-0.5 text-primary shrink-0">{n.type === "receipt" ? <UploadSimple weight="bold" size={16} /> : <Receipt weight="bold" size={16} />}</span>
              <span className="min-w-0">
                <span className="block text-sm font-semibold">{n.title}</span>
                <span className="block text-xs text-muted-foreground truncate">{n.message}</span>
                <span className="block text-[10px] text-muted-foreground mt-0.5">{new Date(n.created_at).toLocaleString("es-MX")}</span>
              </span>
            </button>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
